export const familiesTable = [
  {
    name: "Nombre",
    selector: (row) => row.nombre.toUpperCase(),
    sortable: true,
    width: '160px'
  },
  {
    name: "Apellido",
    selector: (row) => row.apellido.toUpperCase(),
    sortable: true,
    width: '160px'
  },
  {
    name: "Domicilio",
    selector: (row) => row.domicilio,
    sortable: true,
    width: '160px',
  },
  {
    name: "Localidad",
    selector: (row) => row.localidad,
    sortable: true,
    width: "160px",
  },
  {
    name: "DNI",
    selector: (row) => row.dni,
    width: 'auto',
  },
  {
    name: "Código dispositivo",
    selector: (row) => (
      <div>
        <p>{row.codigo_ovitrampa} </p>
        <p>{row.codigo_aspersor}</p>
      </div>
    ),
    width: 'auto',
  },
  {
    name: "Fecha Carga",
    selector: (row) => row.fecha_carga,
    width: 'auto',
    sortable: true,
  },
  {
    name: "Programa",
    selector: (row) => row.program,
    sortable: true,
    width:'160px'
  },
  {
    name: "Reportes",
    selector: (row) => row.report,
    width: '160px',
  },
  {
    name: "Modificar",
    selector: (row) => row.acept,
    width: '160px',
  },
  {
    name: "Deshabilitar",
    selector: (row) => row.delete,
    width: '160px',
  },
];
